// Ported from the Polaris kit: src/components/ui/command/index.js.
// Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs.
// Change the design in the kit first, then re-port.
// Hand change (phase P): CommandDialog.vue left out; the ⌘K palette stays the woot's (R2-X-6), and nothing else
// opens a command dialog. A re-port brings it back: delete it again.
import { createContext } from 'reka-ui';

export { default as Command } from './Command.vue';
export { default as CommandEmpty } from './CommandEmpty.vue';
export { default as CommandGroup } from './CommandGroup.vue';
export { default as CommandInput } from './CommandInput.vue';
export { default as CommandItem } from './CommandItem.vue';
export { default as CommandList } from './CommandList.vue';
export { default as CommandSeparator } from './CommandSeparator.vue';
export { default as CommandShortcut } from './CommandShortcut.vue';

export const [useCommand, provideCommandContext] = createContext('Command');

export const [useCommandGroup, provideCommandGroupContext] =
  createContext('CommandGroup');
